import React from 'react';
import AppShowcasePage from './AppShowcasePage';
import { appShowcases } from '../content/appShowcases';

export default function AblackcloudApp() {
  return <AppShowcasePage slug="ablackcloudapp" content={appShowcases.ablackcloudapp} />;
}
